function inputJudge(form,obj,mes){
	form.onsubmit=function(){
		var filter  = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
		if(obj[0].value.replace(/(^\s*)|(\s*$)/g,"")==''){
			alert('Please enter your Name!');
			obj[0].focus();
			return false;
		}
		if(obj[1].value.replace(/(^\s*)|(\s*$)/g,"")==''){
			alert('Please enter your Email!');
			obj[1].focus();
			return false;
		}
        if(!filter.test(obj[1].value)){
            alert('Email error, please enter again!');
            obj[1].focus();
            return false;
        }
		if(obj[2].value.replace(/(^\s*)|(\s*$)/g,"")==''){
			alert('Please enter your Phone number!');
			obj[2].focus();
			return false;
		}
		if(mes.value.replace(/(^\s*)|(\s*$)/g,"")==''){
			alert('Tell us your idea!');
			mes.focus();
			return false;
		}
        if(obj[3].value.replace(/(^\s*)|(\s*$)/g,"")==''){
			alert('Please upload your design file!');
			obj[3].focus();
			return false;
		}
	}	
}

function inputJudge_c(form,obj,mes){
	form.onsubmit=function(){
		var filter  = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
		if(obj[1].value.replace(/(^\s*)|(\s*$)/g,"")==''){
			alert('Name can not be empty!');
			obj[1].focus();
			return false;
		}
		if(obj[2].value.replace(/(^\s*)|(\s*$)/g,"")==''){
			alert('Email can not be empty!');
			obj[2].focus();
			return false;
		}
		if(obj[3].value.replace(/(^\s*)|(\s*$)/g,"")==''){
			alert('Company can not be empty!');
			obj[3].focus();
			return false;
		}
		if(mes.value.replace(/(^\s*)|(\s*$)/g,"")==''){
			alert('Content can not be empty!');
			mes.focus();
			return false;
		}
        if(!filter.test(obj[2].value)){
            alert('Email input error,please input again!');
            obj[2].focus();
            return false;
        }
	}	
}

function inputJudge_b(form,obj,mes){
    form.onsubmit=function(){
        var filter  = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
        if(obj[1].value.replace(/(^\s*)|(\s*$)/g,"")==''){
            alert('Name can not be empty!');
            obj[1].focus();
            return false;
        }
        if(obj[2].value.replace(/(^\s*)|(\s*$)/g,"")==''){
            alert('Email can not be empty!');
            obj[2].focus();
            return false;
        }
        if(obj[3].value.replace(/(^\s*)|(\s*$)/g,"")==''){
            alert('Phone can not be empty!');
            obj[3].focus();
            return false;
        }
        if(obj[4].value.replace(/(^\s*)|(\s*$)/g,"")==''){
            alert('Company can not be empty!');
            obj[4].focus();
            return false;
        }
        if(obj[5].value.replace(/(^\s*)|(\s*$)/g,"")==''){
            alert('Title can not be empty!');
            obj[5].focus();
            return false;
        }
        if(mes.value.replace(/(^\s*)|(\s*$)/g,"")==''){
            alert('Content can not be empty!');
            mes.focus();
            return false;
        }
        if(!filter.test(obj[2].value)){
            alert('Email input error,please input again!');
            obj[2].focus();
            return false;
        }
    }   
}

function inputJudge_a(form,obj){
    form.onsubmit=function(){
        var filter  = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
        if(obj[1].value.replace(/(^\s*)|(\s*$)/g,"")==''){
            alert('Email can not be empty!');
            obj[1].focus();
            return false;
        }
        if(!filter.test(obj[1].value)){
            alert('Email input error,please input again!');
            obj[2].focus();
            return false;
        }
    }   
}